import { defineNuxtPlugin } from "#app";

export default defineNuxtPlugin((nuxtApp) => {
  // Vue 컴포넌트 에러 핸들러
  nuxtApp.vueApp.config.errorHandler = (err, instance, info) => {
    console.error("[Vue Error]:", err, info);
    // 에러를 콘솔에 기록하고 흐름 유지
  };

  // Nuxt 전역 에러 핸들러
  nuxtApp.hook("app:error", (err) => {
    console.error("[Nuxt Error]:", err);
    // 에러를 콘솔에 기록하고 아무 작업도 수행하지 않음
  });
});